import { Avatar, Card, CardHeader, Skeleton, useTheme } from '@mui/material';

import { getStyled } from './styles';

const TicketHeaderSkeleton = () => {
  const theme = useTheme();
  const classes = getStyled(theme);

  return (
    <Card sx={classes.ticketHeader}>
      <CardHeader
        avatar={
          <Skeleton animation='wave' variant='circle'>
            <Avatar alt='contact_image' />
          </Skeleton>
        }
        title={<Skeleton animation='wave' width={80} />}
        subheader={<Skeleton animation='wave' width={140} />}
      />
    </Card>
  );
};

export default TicketHeaderSkeleton;
